import React from 'react'

export default function Anchor ( props ) {

	return (
		<div className="anchor" id={ props.anchorId }></div>
	)
}